import {SAVE_NAVIGATIONS} from '../constant';

const initial = {
    home: {
        desc: "Home", data: [
            {menu: "home", display: "Home"},
        ]
    },
    dashboard: {
        desc: "Dashboard",
        data: [
            {menu: "dashboard-transaction", display: "Transaction"},
            {menu: "dashboard-summary", display: "Summary"},
        ]
    },
    sale: {
        desc: "Sale",
        data: [
            {menu: "sale-airtime", display: "Airtime"},
            {menu: "sale-data", display: "Data"},
            {menu: "sale-bulk", display: "Bulk"},
        ]
    },
    Wallet: {
        desc: "Wallet",
        data: [
            {menu: "wallet-balance", display: "Account Status"},
            /*{menu: "wallet-transfer", display: "Transfer"},*/
            {menu: "wallet-topup", display: "Top Up"},
        ]
    },
    setting: {
        desc: "Settings",
        data: [
            {menu: "setting-dealer", display: "Dealer"},
            {menu: "setting-agent", display: "Agent"},
            {menu: "setting-commission", display: "Commission"},
            {menu: "setting-bundles-category", display: "Bundle Category"},
            {menu: "setting-bundles-list", display: "Bundle List"},
            {menu: "setting-dealer-banking", display: "Banking"},
        ]
    },
    recon: {
        desc: "Recon",
        data: [
            {menu: "recon-history", display: "History"},
            {menu: "recon-report", display: "Report"},
        ]
    },

}


const reduceNavigations = (state = initial, action) => {
    let newState = state;
    switch (action.type) {
        case SAVE_NAVIGATIONS:
            newState = action.payload;
            return Object.assign({}, newState);
        default:
            return state
    }
}

export default reduceNavigations;
